<template lang="pug">
.avatar.avatar_initial(
  :class="sizeClass"
  :style="{ backgroundColor: displayColor }"
)
  slot {{ letter }}
</template>

<script>
import ColorUtilsMixin from '~/mixins/color_utils';

export default {
  name: 'AppAvatarInitial',
  mixins: [ColorUtilsMixin],
  props: {
    text: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      default: 'medium',
    },
    projectColor: {
      type: String,
      default: '',
    },
  },
  computed: {
    sizeClass() {
      return `avatar-${this.size}`;
    },
    displayColor() {
      if (this.projectColor) {
        return this.projectColor;
      }

      return this.stringToColor(this.text);
    },
    letter() {
      return this.text[0].toUpperCase();
    },
  },
};
</script>
